var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutWide',[_c('sub-nav-bar',{attrs:{"page":"Marketing"}}),_c('div',[_c('HeroBox',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"color":_vm.color}})],1),_c('div',[_c('GetAllVisitableCustomerSearchComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }